module.exports = __webpack_public_path__ + "34c4f91c5c21191f2e2ff879a2b24c72.png";